import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { stores, view } from '../../../stores'

import { toIntOrDefault } from '../../../utilities/numbers'
import { Price } from '../../ui/inputs/Price'
import { Loader } from '../../ui/states/Loader'
import { Accordion } from '../../accordion/Accordion'
// Kept commented along with the card top-up accordion below (see the comment there)
// import CreditCardPaymentContent from './payments/credit/CreditCardPaymentContent'
import TransfertPaymentContent from './payments/transfert/TransfertPaymentContent'
import CesuPaymentContent from './payments/cesu/CesuPaymentContent'
import ChequePaymentContent from './payments/cheque/ChequePaymentContent'

import './Wallet.css'

class WalletComponent extends Component {
  async componentDidMount () {
    await stores.account.getWallet()
  }

  render () {
    const { t } = this.props
    const { wallet } = stores.account

    return (<div className='box box--grey'>
      <div className='available-funds'>
        <span>
          {t('common:payment:available')}:&nbsp;
                {
                  stores.account.wallet.loading
                    ? <Loader size='small' />
                    : <Price value={toIntOrDefault(wallet.balance, 0)} />
                }
        </span>
      </div>
      {/*
        Card top-up is disabled since the Lemonway -> Axepta migration. Lemonway held the customers'
        money (e-money licence), which is what made a prepaid balance possible; Axepta only cashes a
        card in to our bank account, so a card top-up would take the money without crediting anything.
        Customers who want to pay in advance are handled manually in accounting — the transfer / CESU /
        cheque options below still cover that. The balance above stays visible and spendable.
        To re-enable one day, uncomment this and the button in CreditCardPaymentContent.
        <Accordion title={t('common:payment:reload:credit_card')} additionalComponent={<CreditCardPaymentContent />} />
      */}
      <Accordion title={t('common:payment:reload:transfert')} additionalComponent={<TransfertPaymentContent walletIban={wallet.iban} />} />
      <Accordion title={t('common:payment:reload:cesu')} additionalComponent={<CesuPaymentContent />} />
      <Accordion title={t('common:payment:reload:cheque')} additionalComponent={<ChequePaymentContent />} />
    </div>
    )
  }
}

WalletComponent.propTypes = { t: func }

export const Wallet = translate()(view(WalletComponent))



// WEBPACK FOOTER //
// ./src/components/customer/wallet/Wallet.js